import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Estado } from '../models/estado.model';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Cidade } from '../models/cidade.model';
import { Bairro } from '../models/bairro';

export interface Region {
  value: number;
  label: string;
  parent: RegionTree;
}
export interface RegionTree extends Region {
  children?: (Region | RegionTree)[];
}

@Injectable({
  providedIn: 'root',
})
export class IbgeService {
  private baseUrl = `${environment.apiUrl}/ibge`;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  static treeRegionsCached: RegionTree[] = null;

  async getTreeRegions(): Promise<RegionTree[]> {
    if (IbgeService.treeRegionsCached) {
      return IbgeService.treeRegionsCached;
    }
    const response = await this.http
        .get<RegionTree[]>(this.baseUrl + '/TreeRegions', { headers: this.headers })
        .toPromise();

    (function setParent(node: (RegionTree | Region)[], parent = null) {
      node.forEach(x => {
        x.parent = parent;
        if ((x as RegionTree).children) {
          setParent((x as RegionTree).children, x);
        }
      });
    })(response);

    IbgeService.treeRegionsCached = response;

    return IbgeService.treeRegionsCached;
  }

  getRegionsId(id) {
    return this.http
      .get<any>(this.baseUrl + '/TreeRegions/' + id, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getUfs(): Observable<Estado[]> {
    return this.http.get<any>(this.baseUrl + '/GetListUf/').pipe(
      tap(),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  getCities(ids: any[]): Observable<Cidade[]> {
    return this.http.post<any>((this.baseUrl + `/GetListCitiesByUf`), ids).pipe(
      tap(),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  getDistricts(ids: any[]): Observable<Bairro[]> {
    return this.http.post<any[]>((this.baseUrl + `/GetAllDistrictsByCity`), ids).pipe(
      tap(),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }
}
